import { UserDialogComponent } from './../user-dialog/user-dialog.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { TranslateModule } from '@ngx-translate/core'

import { WidgetModule } from '../widget/widget.module'
import { ChartModule } from './chart/chart.module'

import { MapComponent } from './map/map.component'
import { HeaderComponent } from './header/header.component'
import { FooterComponent } from './footer/footer.component'
import { FilterBarComponent } from './filter-bar/filter-bar.component'
import { CategoryFilterComponent } from './category-filter/category-filter.component'

import { SummaryComponent } from './summary/summary.component'
import { RouterModule } from '@angular/router'
import { LatitudeAltModule } from '../latitude/latitude.module'
import { CapitalizePipe } from './capitalize.pipe'
import { CitySelectorComponent } from './city-selector/city-selector.component'
import { MapHoverPopupComponent } from './map-hover-popup/map-hover-popup.component'
import { MapClickPopupComponent } from './map-click-popup/map-click-popup.component'
import { FilterCitySelectorComponent } from './filter-city-selector/filter-city-selector.component'
import { MapAttributeComponent } from './map-attribute/map-attribute.component'

import { ClickOutsideDirective } from '../utils/click-outside.directive'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BtnGroupComponent } from './btn-group/btn-group.component'
import { TableComponent } from './table/table.component'
import { CheckboxComponent } from './checkbox/checkbox.component'
import { ModalComponent } from './modal/modal.component'
import { ButtonComponent } from './button/button.component'
import { TagSelectorComponent } from './tag-selector/tag-selector.component'
import { CampaignFilterBarComponent } from './campaign-filter-bar/campaign-filter-bar.component'
import { SlicePipe } from './slice.pipe'
import { PopupRankingCampaignsComponent } from './popup-ranking-campaigns/popup-ranking-campaigns.component'
import { NgxSliderModule } from '@angular-slider/ngx-slider'
import { CampaignCreationMenuComponent } from '../campaign-creation-menu/campaign-creation-menu.component'
import { CampaignCreationModalComponent } from '../campaign-creation-modal/campaign-creation-modal.component'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatNativeDateModule } from '@angular/material/core'

const modules = [
  MapComponent,
  HeaderComponent,
  FooterComponent,
  FilterBarComponent,
  CategoryFilterComponent,
  SummaryComponent,
  CapitalizePipe,
  SlicePipe,
  CitySelectorComponent,
  MapHoverPopupComponent,
  MapClickPopupComponent,
  FilterCitySelectorComponent,
  MapAttributeComponent,
  UserDialogComponent,
  ClickOutsideDirective,
  BtnGroupComponent,
  TableComponent,
  CheckboxComponent,
  ModalComponent,
  ButtonComponent,
  TagSelectorComponent,
  CampaignFilterBarComponent,
  PopupRankingCampaignsComponent,
  CampaignCreationMenuComponent,
  CampaignCreationModalComponent,
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    LatitudeAltModule,
    TranslateModule,
    WidgetModule,
    ChartModule,
    BrowserAnimationsModule,
    NgxSliderModule,
    ScrollingModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
  ],
  declarations: [...modules],
  exports: [...modules, WidgetModule, ChartModule],
})
export class CommonCompModule {}
